import React, { useState } from "react";
import Slide from "../HomepageSlider/Slide";

const Offers = ({ offers, filter, count }) => {
  const [offersItems, setOffers] = useState(offers);
  const [page, setPage] = useState(2);
  const [last, setLast] = useState(offers.length)

  const axios = require('axios');
  const url = window.location.pathname;

  axios.defaults.headers.common['Accept'] = 'application/json';

  const handleSubmit = e => {
    e.preventDefault();

    axios.get(url, {
      params: { page: page }
    }, {headers: {'Content-Type': 'text/javascript'}})
    .then(function (response) {
      for (var i=0; i < response.data.length; i++) {
        offersItems.push(response.data[i]);
      }
      setOffers([...offersItems]);
      setPage(page + 1);
      setLast(response.data.length)
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  function Cards(props) {
    const element = props.element;
    return (
      <div className="cabinet-offers__offer">
        <Slide
          title={element.title}
          duration={element.duration}
          link={element.link}
          oldPrice={element.oldPrice}
          newPrice={element.newPrice}
          image={element.image}
          className={element.className}
          description={element.description}
        />
      </div>
    )
  }

  return (
    <div>
      <div className="cabinet-offers__offers">
        {offersItems.map((element, elIndex) => (
          <Cards key={elIndex} element={element} />
        ))}
      </div>
      {last >= count &&
        <div className="cabinet-offers__button-wrapper">
          <a className="button button_large" onClick={handleSubmit} rel="next">Загрузить еще</a>
        </div>
      }
    </div>
  )
}

export default Offers;
